import m from "../../geodata/es2015/liechtensteinHigh";
window.am4geodata_liechtensteinHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/liechtensteinHigh.js
// module id = null
// module chunks = 